AOS.init();

document.addEventListener("DOMContentLoaded", function () {
    const element = document.querySelector(".toolTipProd");

    if (!element) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    element.classList.add("active");
                } else {
                    element.classList.remove("active");
                }
            });
        },
        {
            threshold: 0.3
        }
    );

    observer.observe(element);
});


document.addEventListener("DOMContentLoaded", function () {
    const boxes = document.querySelectorAll(".videRevBx");

    boxes.forEach(function (box) {
        const video = box.querySelector("video");
        const playBtnHldr = box.querySelector(".videoPlayBtnHldr");

        function pauseVideo(v, btn, b) {
            v.pause();
            v.removeAttribute("controls");
            b.classList.remove("active");
            btn.style.display = "flex";
        }

        function playVideo(v, btn, b) {
            boxes.forEach(function (otherBox) {
                const otherVideo = otherBox.querySelector("video");
                const otherBtn = otherBox.querySelector(".videoPlayBtnHldr");
                if (!otherVideo.paused) {
                    pauseVideo(otherVideo, otherBtn, otherBox);
                    otherVideo.currentTime = 0;
                }
            });

            v.muted = false;
            v.play();
            v.setAttribute("controls", "controls");
            b.classList.add("active");
            btn.style.display = "none";
        }

        playBtnHldr.addEventListener("click", function () {
            if (video.paused) {
                playVideo(video, playBtnHldr, box);
            } else {
                pauseVideo(video, playBtnHldr, box);
            }
        });

        video.addEventListener("click", function () {
            if (video.paused) {
                playVideo(video, playBtnHldr, box);
            } else {
                pauseVideo(video, playBtnHldr, box);
            }
        });

        video.addEventListener("ended", function () {
            playBtnHldr.style.display = "flex";
            video.currentTime = 0;
            video.removeAttribute("controls");
            box.classList.remove("active");
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const allAccordions = document.querySelectorAll(".accordion-item");

  // Default: har group ka pehla open ho
  const groups = new Map();

  allAccordions.forEach((item) => {
    const header = item.querySelector(".accordion-item-header");
    const body = item.querySelector(".accordion-item-body");
    if (!header || !body) return;

    // Group check (parent ke hisaab se)
    const parent = item.parentElement;
    if (!groups.has(parent)) {
      groups.set(parent, true); // mark first open
      header.classList.add("active");
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      body.style.maxHeight = "0px";
    }

    // Toggle functionality
    header.addEventListener("click", function () {
      const isActive = header.classList.contains("active");

      // Pehle sab band karo (sirf is parent ke andar)
      parent.querySelectorAll(".accordion-item-header").forEach((h) => {
        h.classList.remove("active");
        const b = h.nextElementSibling;
        if (b) b.style.maxHeight = "0px";
      });

      // Agar abhi active nahi tha to isko open karo
      if (!isActive) {
        header.classList.add("active");
        body.style.maxHeight = body.scrollHeight + "px";
      }
    });
  });

  // Resize hone par height adjust
  window.addEventListener("resize", () => {
    document.querySelectorAll(".accordion-item-header.active").forEach((header) => {
      const body = header.nextElementSibling;
      if (body) body.style.maxHeight = body.scrollHeight + "px";
    });
  });
});



